'use client'

import s from './style.module.scss'
import CometLink from '@app/components/custom-links/comet-link'
import {GameEvent} from '@app/[lang]/(common-header-footer)/(home)/events'
import {tagPath} from '@app/[lang]/(common-header-footer)/tags/constants'
import triggerAnalytics from '@gamezop/analytics-sdk/client/trigger-analytics'
import clsx from 'clsx'

type Props = {
  text: string
  iconSrc: string
  href: string
  order?: number
  layout?: string
  nameEn: string
  emoji: string
  tagId?: number
  isActive?: boolean
  isMobile: boolean
}

const TagIconAndName = ({text, iconSrc, href, order, layout, nameEn, emoji, tagId, isActive, isMobile}: Props) => {
  return (
    <CometLink
      href={`/${tagPath}/${href}`}
      className={clsx(s.container, {
        [s.active_container]: isActive,
        [s.desktop_container]: !isMobile,
      })}
      onClick={() => {
        triggerAnalytics(GameEvent.CategorySelected, {
          layout,
          order,
          'category-name': nameEn,
        }).sendAll()
      }}
    >
      {/* <Image src={iconSrc} alt={text} width={28} height={28} className={s.icon} /> */}
      <span className={s.emoji}>{emoji}</span>
      <p
        className={clsx(s.text, {
          [s.active_text]: isActive,
        })}
      >
        {text}
      </p>
    </CometLink>
  )
}

export default TagIconAndName
